import React from 'react';
import { Row, Col, Spin, Alert } from 'antd';

import 'antd/dist/antd.css';
import "./Dashboard.css";
import QMSErrorHandle from './../../auxil/QMSErrorHandle';

import { axiosInstance2 } from "../../../utils/axiosConfig";

let accessType = {
    END_USER: 'END_USER',
    CORPORATE: 'CORPORATE',
    ONBOARDING_TEAM: 'ONBOARDING_TEAM'
}

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            alertObj : "File upload sessions availability check in progress...",
            message : ""
        }
    }

    errorObject = {
        err: false, 
        errCode: null, 
        errType: null, 
        errMsg: null, 
        display : false
    }

    printError(newError){
        this.errorObject = newError;
        //this.forceUpdate();
        this.setState({ alertObj : "No file upload sessions" });
        setTimeout(() => { 
            this.errorObject = {
                err: false, 
                errCode: null, 
                errType: null, 
                errMsg: null, 
                display : false
            }
        },
        1000);
    }

    componentDidMount(){
        let pms = sessionStorage.getItem('pms');
        let userName = this.props.user["https://myapp.com/UserName"];
        
        axiosInstance2.post('/api/fileTrace/checkFiletraceExistingData',
        {
            userName: userName,
            pms: pms,
            from: (this.props.accessType === accessType.END_USER)?("FT"):("GM")
        })
        .then(response => {
            
            if(!response["data"]["error"]){
                if(response["data"]["dataExists"]){
                    if(this.props.accessType === accessType.END_USER){
                        this.setState({ alertObj : "Please select a session from the File Tracing menu to view the status of the files uploaded" });
                    }else{
                        this.setState({ alertObj : "Please select File Tracing menu to view the status of the files uploaded" });
                    }
                }else{
                    this.setState({ alertObj : "No file upload sessions" });
                }
            }else{
                let errorMessage = (response["data"]["display"] != undefined && response["data"]["display"])?response["data"]["errorMessage"]:'Error occured';
                this.printError({
                    display: true,
                    err: true,
                    errCode: '500',
                    errType: '',
                    errMsg: errorMessage
                });
                return;
            }
        }).catch(error => {
            console.error("ERROR :", error);
            this.printError({
                display: true,
                err: true,
                errCode: '400',
                errType: '',
                errMsg: 'Error occured : '+error.message
            });   
            //this.setState({ alertObj : ""}); 
        });
    }

    render(){
        return(
            <div className="dashboard">
                {/* <Spin tip='Loading...'
                    spinning={this.state.contentLoadingStatus}
                > */}
                    <QMSErrorHandle errordetails={this.errorObject} />
                    <Row gutter={[40, 32]} type="flex" justify="space-around">
                        <Col span={23}>
                            <div className="dashboardMsg">Welcome to Quality Management System</div>
                            <Alert 
                                message={this.state.message}
                                description={this.state.alertObj}
                                type="info"
                                showIcon
                                hidden={true}
                            />
                        </Col>
                    </Row>
                {/* </Spin> */}
            </div>
        )
    }
        
}

export default Dashboard;